import React, { useMemo } from 'react';
import { Popup } from '@leverege/ui-elements';
import { R } from '@leverege/value-resolver';
import { jsx as _jsx } from "react/jsx-runtime";
export default function SectionSelector({
  title,
  icon,
  divider = false,
  value,
  values,
  nameKey = 'name',
  valueKey = 'value',
  iconKey = 'icon',
  layoutKey = 'layout',
  eventData,
  onChange,
  variant = 'sectionSelector',
  toggleVariant = 'sectionSelector',
  toggleAttributes,
  ...rest
}) {
  const cValue = values.find(item => {
    return value == null ? item[valueKey] == null : item[valueKey] === value;
  });
  let cTitle = title;
  if (typeof cTitle === 'function') {
    cTitle = cTitle(cValue, values);
  }
  let cIcon = icon;
  if (typeof cIcon === 'function') {
    cIcon = cIcon(cValue, values);
  }
  const onSelect = evt => {
    onChange?.({
      value: evt.value,
      data: eventData || evt.data
    });
  };
  const sortedValues = useMemo(() => {
    const nValues = [...values];
    return nValues.sort((a, b) => {
      const sortA = a?.[layoutKey]?.sort || '';
      const sortB = b?.[layoutKey]?.sort || '';
      const rSortA = R(sortA);
      const rSortB = R(sortB);
      if (rSortA === rSortB) {
        return 0;
      }
      if (rSortA > rSortB) {
        return 1;
      }
      return -1;
    });
  }, [values, layoutKey]);
  const content = useMemo(() => {
    let sectionCurr = '';
    return sortedValues.reduce((acc, value) => {
      const section = value[layoutKey]?.section || '';
      const rSection = R(section);
      const rIcon = R(value[iconKey]);
      const rName = R(value[nameKey]);
      const rValue = R(value[valueKey]);
      if (rSection !== '' && rSection !== sectionCurr) {
        if (divider) {
          acc.push(/*#__PURE__*/_jsx(Popup.Divider, {}, `Divider-${rSection}`));
        }
        acc.push(/*#__PURE__*/_jsx(Popup.Header, {
          children: rSection
        }, `Header-${rSection}`));
        sectionCurr = rSection;
      }
      const checked = value == null ? rValue === null : rValue === value;
      acc.push(/*#__PURE__*/_jsx(Popup.Item, {
        eventData: value,
        checked: checked,
        icon: rIcon,
        value: rValue,
        onClick: onSelect,
        children: rName
      }, `Item-${rSection}-${rName}-${hashCode(JSON.stringify(rValue))}`));
      return acc;
    }, []);
  }, [divider, iconKey, nameKey, sortedValues, valueKey]);
  return /*#__PURE__*/_jsx(Popup, {
    variant: variant,
    title: cTitle,
    icon: cIcon,
    toggleVariant: toggleVariant,
    toggleAttributes: toggleAttributes,
    setPopupMinWidth: true,
    ...rest,
    children: content
  });
}
function hashCode(s) {
  return s.split('').reduce((a, b) => {
    a = (a << 5) - a + b.charCodeAt(0);
    return a & a;
  }, 0);
}